<template>
  <div class="dashboard_layout">
    <dashboard-header class="" />
    <div class="">
      <router-view class="" />
    </div>
    <transition name="loading">

    </transition>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { EventBus } from '@/libs/event-bus'
import DashboardHeader from '@/components/dashboard/Header'

export default {
  name: 'DashboardLayout',
  components: {
    DashboardHeader,
  },
  created () {

  },
  methods: {
    ...mapMutations([
      'setErrorData'
    ])
  },
  computed: {

  },
  data () {
    return {

    }
  }
}
</script>

<style lang="scss">
.dashboard_layout {
  width: 100%;
  height: 100%;
  min-height: 830px;
  margin: 0px auto 0;
}
</style>
